import { render, staticRenderFns } from "./signup.vue?vue&type=template&id=b8b5866c&"
import script from "./signup.vue?vue&type=script&lang=js&"
export * from "./signup.vue?vue&type=script&lang=js&"
import style0 from "./signup.vue?vue&type=style&index=0&id=b8b5866c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports